'use strict';
define('bidsService',['settings'], function (settings) {
	var eventSource = [];

	return {
		listenForBids: listenForBids
	};

	function listenForBids(uuid, gameNo, cb) {
		if (eventSource[gameNo]) {
			eventSource[gameNo].close();
		}
		eventSource[gameNo] = new EventSource(settings.games[gameNo].bidsServiceURL + '/pool/' +
			settings.games[gameNo].bidsPool + '/instance/' + uuid + '/stream');
		eventSource[gameNo].onmessage = function (e) {
			cb(JSON.parse(e.data), gameNo);
		};
		eventSource[gameNo].onerror = function (e) {
			if (e.target.readyState === EventSource.CLOSED) {
				eventSource[gameNo].close();
				setTimeout(function () {
					listenForBids(uuid, gameNo, cb);
				}, 1000);
			}
		};
	}
});

